import { IconProps } from "@design-system/types";

export function RightIcon() {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="rtl:rotate-180"
    >
      <path
        d="M8.85547 5.70842L16.1471 13.0001L8.85547 20.2917"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronIcon(props: IconProps) {
  return (
    <svg
      width="40"
      height="39"
      viewBox="0 0 40 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.4453 8.31955L25.6259 19.5001L14.4453 30.6807"
        stroke={props.color || "#FE4F02"}
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VideoPlayIcon(props: IconProps) {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="1" y="1" width="63" height="63" rx="31.5" fill="white" />
      <rect
        x="1"
        y="1"
        width="63"
        height="63"
        rx="31.5"
        stroke={props.color || "#FE4F02"}
        strokeWidth="2"
      />
      <path
        d="M24.1667 32.5V28.7917C24.1667 24.1875 27.4271 22.3021 31.4167 24.6042L34.6354 26.4584L37.8542 28.3125C41.8437 30.6146 41.8437 34.3854 37.8542 36.6875L34.6354 38.5417L31.4167 40.3959C27.4271 42.6979 24.1667 40.8125 24.1667 36.2084V32.5Z"
        fill={props.color || "#FE4F02"}
      />
    </svg>
  );
}
